var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgE1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_638",
    "data-name": "Group 638",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 56,
    height: 56,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "school_4_",
    "data-name": "school (4)",
    transform: "translate(2.584 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 47.393,
    height: 29.707,
    transform: "translate(2.331 17.68)",
    fill: "#f6c358"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 2.827,
    height: 4.902,
    transform: "translate(44.924 22.51)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M368.812,200.127v-4.9h2.827Z",
    transform: "translate(-323.888 -172.715)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 2.827,
    height: 4.902,
    transform: "translate(44.924 30.184)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M368.812,263.118v-4.9h2.827Z",
    transform: "translate(-323.888 -228.033)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 2.827,
    height: 4.902,
    transform: "translate(44.924 37.855)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M368.812,326.109v-4.9h2.827Z",
    transform: "translate(-323.888 -283.351)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 2.827,
    height: 4.902,
    transform: "translate(40.267 22.51)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M330.6,200.127v-4.9h2.827Z",
    transform: "translate(-290.327 -172.715)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 2.827,
    height: 4.902,
    transform: "translate(40.267 30.184)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M330.6,263.118v-4.9h2.827Z",
    transform: "translate(-290.327 -228.033)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 2.827,
    height: 4.902,
    transform: "translate(40.267 37.855)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M330.6,326.109v-4.9h2.827Z",
    transform: "translate(-290.327 -283.351)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 2.827,
    height: 4.902,
    transform: "translate(35.616 22.51)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M292.38,200.127v-4.9h2.828Z",
    transform: "translate(-256.766 -172.715)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 2.827,
    height: 4.902,
    transform: "translate(35.616 30.184)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M292.38,263.118v-4.9h2.828Z",
    transform: "translate(-256.766 -228.033)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 2.827,
    height: 4.902,
    transform: "translate(35.616 37.855)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M292.38,326.109v-4.9h2.828Z",
    transform: "translate(-256.766 -283.351)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M59.349,82.622H26.327l-7.186,8.884H66.535Z",
    transform: "translate(-16.809 -73.828)",
    fill: "#64798a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M224.906,17.7a4.119,4.119,0,0,0-5.838-1.407c-1.085.633-.782-.92-2.5.426V10.5s.153,2.3,3.805.573a5.365,5.365,0,0,1,4.535-.261S226.626,13.319,224.906,17.7Z",
    transform: "translate(-190.186 -10.426)",
    fill: "#44c4a1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 1.251,
    height: 11.572,
    transform: "translate(25.323 0.078)",
    fill: "#dc8744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M167.059,93.4v32.4h-14.8V92.464l7.4-4.618,7.4,4.618Z",
    transform: "translate(-133.708 -78.416)",
    fill: "#fcd462"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 5.052,
    cy: 5.052,
    r: 5.052,
    transform: "translate(20.828 12.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M173.6,123.759a5.39,5.39,0,1,1,5.39-5.39A5.4,5.4,0,0,1,173.6,123.759Zm0-10.1a4.715,4.715,0,1,0,4.715,4.715A4.72,4.72,0,0,0,173.6,113.654Z",
    transform: "translate(-147.723 -100.487)",
    fill: "#3a556a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(21.66 13.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M207.133,122.384h.353v.971h-.156v-.825h-.2v-.146Z",
    transform: "translate(-203.562 -122.36)",
    fill: "#2f4859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M212.165,122.591a.194.194,0,0,0,.042-.115.13.13,0,0,0-.045-.1.159.159,0,0,0-.112-.041.232.232,0,0,0-.2.122l-.132-.077a.482.482,0,0,1,.141-.144.367.367,0,0,1,.2-.049.321.321,0,0,1,.213.077.261.261,0,0,1,.092.21.285.285,0,0,1-.039.143.971.971,0,0,1-.143.175l-.228.232h.44v.157h-.664v-.139l.295-.3A1.568,1.568,0,0,0,212.165,122.591Z",
    transform: "translate(-207.59 -122.188)",
    fill: "#2f4859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M178.119,153.966a.216.216,0,0,0,.19-.087.413.413,0,0,0,.063-.236.35.35,0,0,1-.1.073.308.308,0,0,1-.144.034.3.3,0,0,1-.219-.087.309.309,0,0,1-.088-.231.3.3,0,0,1,.1-.231.341.341,0,0,1,.24-.087.322.322,0,0,1,.322.208.694.694,0,0,1,.05.27.837.837,0,0,1-.032.25.4.4,0,0,1-.087.158.353.353,0,0,1-.266.114.455.455,0,0,1-.286-.1l.082-.121a.312.312,0,0,0,.085.05A.254.254,0,0,0,178.119,153.966Zm.03-.361a.212.212,0,0,0,.14-.047.149.149,0,0,0,.056-.121.173.173,0,0,0-.054-.128.185.185,0,0,0-.136-.053.191.191,0,0,0-.134.048.159.159,0,0,0-.053.123.178.178,0,0,0,.048.127A.172.172,0,0,0,178.149,153.6Z",
    transform: "translate(-177.82 -149.346)",
    fill: "#2f4859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M210.051,184.668a.216.216,0,0,0-.19.088.411.411,0,0,0-.062.236.351.351,0,0,1,.1-.073.308.308,0,0,1,.144-.034.3.3,0,0,1,.219.087.308.308,0,0,1,.088.231.3.3,0,0,1-.1.231.341.341,0,0,1-.24.087.322.322,0,0,1-.322-.208.694.694,0,0,1-.05-.27.834.834,0,0,1,.032-.25.4.4,0,0,1,.088-.158.353.353,0,0,1,.266-.114.456.456,0,0,1,.286.1l-.082.121a.314.314,0,0,0-.085-.05A.253.253,0,0,0,210.051,184.668Zm-.03.361a.213.213,0,0,0-.14.047.15.15,0,0,0-.056.121.174.174,0,0,0,.054.128.185.185,0,0,0,.136.053.2.2,0,0,0,.136-.048.156.156,0,0,0,.054-.122.175.175,0,0,0-.184-.178Z",
    transform: "translate(-205.767 -176.928)",
    fill: "#2f4859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M241.48,155.253v-.146h.568v.128l-.235.263a.285.285,0,0,1,.208.084.27.27,0,0,1,.075.191.289.289,0,0,1-.1.233.389.389,0,0,1-.259.085.551.551,0,0,1-.31-.1l.069-.132a.431.431,0,0,0,.25.083.232.232,0,0,0,.139-.04.132.132,0,0,0,.055-.114.14.14,0,0,0-.061-.119.284.284,0,0,0-.169-.044.358.358,0,0,0-.1.015v-.125l.225-.261Z",
    transform: "translate(-233.679 -151.097)",
    fill: "#2f4859"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 0.207,
    height: 2.625,
    transform: "translate(4.255 1.857)",
    fill: "#2f4859"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 1.91,
    height: 0.225,
    transform: "translate(2.241 4.373)",
    fill: "#2f4859"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 0.13,
    height: 4.491,
    transform: "matrix(-0.751, 0.66, -0.66, -0.751, 28.239, 20.467)",
    fill: "#e56353"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 0.338,
    cy: 0.338,
    r: 0.338,
    transform: "translate(25.674 17.758)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 51.971,
    height: 2.05,
    transform: "translate(0 47.381)",
    fill: "#3a556a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 6.185,
    height: 9.509,
    transform: "translate(22.855 37.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 2.827,
    height: 4.902,
    transform: "translate(13.833 22.51)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M113.562,200.127v-4.9h2.828Z",
    transform: "translate(-99.729 -172.715)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 2.827,
    height: 4.902,
    transform: "translate(13.833 30.184)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M113.562,263.118v-4.9h2.828Z",
    transform: "translate(-99.729 -228.033)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 2.827,
    height: 4.902,
    transform: "translate(13.833 37.855)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M113.562,326.109v-4.9h2.828Z",
    transform: "translate(-99.729 -283.351)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 2.827,
    height: 4.902,
    transform: "translate(9.178 22.51)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M75.347,200.127v-4.9h2.827Z",
    transform: "translate(-66.169 -172.715)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 2.827,
    height: 4.902,
    transform: "translate(9.178 30.184)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M75.347,263.118v-4.9h2.827Z",
    transform: "translate(-66.169 -228.033)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 2.827,
    height: 4.902,
    transform: "translate(9.178 37.855)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M75.347,326.109v-4.9h2.827Z",
    transform: "translate(-66.169 -283.351)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 2.827,
    height: 4.902,
    transform: "translate(4.523 22.51)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M37.131,200.127v-4.9h2.827Z",
    transform: "translate(-32.608 -172.715)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 2.827,
    height: 4.902,
    transform: "translate(4.523 30.184)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M37.131,263.118v-4.9h2.827Z",
    transform: "translate(-32.608 -228.033)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 2.827,
    height: 4.902,
    transform: "translate(4.523 37.855)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M37.131,326.109v-4.9h2.827Z",
    transform: "translate(-32.608 -283.351)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 4.239,
    height: 3.691,
    transform: "translate(20.487 26.562)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M168.213,232.174v-3.691h4.239Z",
    transform: "translate(-147.723 -201.922)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 4.239,
    height: 3.691,
    transform: "translate(26.921 26.562)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M221.012,232.174v-3.691h4.239Z",
    transform: "translate(-194.091 -201.922)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 4.239,
    height: 3.691,
    transform: "translate(20.58 31.743)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M168.953,274.707v-3.691h4.239Z",
    transform: "translate(-148.373 -239.274)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 4.239,
    height: 3.691,
    transform: "translate(27.011 31.743)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M221.752,274.707v-3.691h4.239Z",
    transform: "translate(-194.741 -239.274)",
    fill: "#27a2db"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgE1);
export default __webpack_public_path__ + "static/media/e1.fca1aad5e745ec86a85bc917a0553d60.svg";
export { ForwardRef as ReactComponent };